import React from 'react';

import { Title } from '../common/container/Container.jsx';
import { Artists as ArtistsSlider } from '../common/container/Slider.jsx';
import { Follow as FollowButton } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { Genre } from '../common/repository/Type.jsx';

let _ArtistsInst;
class Artists extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.featuredCount = 3;

        this.handleFollowChange = this.handleFollowChange.bind(this);
    }

    componentDidMount() {
        _ArtistsInst = true;
    }

    componentWillUnmount() {
        _ArtistsInst = undefined;
    }

    handleFollowChange(id, data, callback) {
        let artist;
        for (let i = 0; i < data.length; i++) {
            let temp = data[i];
            if (!temp || temp.ArtistId != id) {
                continue;
            }
            artist = temp;
            break;
        }
        if (!artist) {
            return;
        }
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !_ArtistsInst) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            callback(data);
        });
    }

    render() {
        const genreSliders = [];
        for (let id in Genre.values) {
            genreSliders.push(<ArtistsForGenre key={id} genre={id} />);
        }
        return (
            <React.Fragment>
                <ArtistCover count={this.featuredCount} onFollowChange={this.handleFollowChange} />
                <div className="section">
                    <div className="container">
                        <ArtistsSlider
                            className="spacer--bottom"
                            id="featured"
                            q={{ limit: 20, offset: this.featuredCount, type: 0 }}
                            slideProps={{ cols: 5, slider: true }}
                            title="Featured Artists"
                            titleSmall={true}
                            url={Artcloud.url.vendor.marketplace.artists.get()} />
                        {genreSliders}
                        <ArtistsSlider
                            id="arrivals"
                            q={{ limit: 20, offset: 0, order: 1 }}
                            style={{ marginTop: '50px' }}
                            title="New Arrivals"
                            titleSmall={true}
                            url={Artcloud.url.vendor.marketplace.artists.get()} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

class ArtistCover extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleFollowChange = this.handleFollowChange.bind(this);
    }

    componentDidMount() {
        const component = this;
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.artists.get(),
            { limit: component.props.count, offset: 0, type: 0 },
            function (responseData) {
                component.request = null;

                responseData.Artists.forEach(function (d) {
                    Artcloud.mkt.artists._isfollowing(d);
                });
                component.setState({
                    data: responseData.Artists
                });
            },
            function (jqXHR, textStatus) {
                component.request = null;
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    componentWillUnmount() {
        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    handleFollowChange(d) {
        const component = this;
        const artists = component.state.data;
        component.props.onFollowChange(d.ArtistId, artists, function (data) {
            component.setState({
                data: data
            });
        });
    }

    render() {
        const data = this.state.data || [];
        return (
            <React.Fragment>
                <div className="section spacer--bottom-none">
                    <div className="container">
                        <div className="section__title section__title--medium">
                            <h2 className="text--center-m">Browse Artists</h2>
                            <div className="letters__header">
                                <a data-letter="a" href="/artists/a">a</a>
                                <a data-letter="b" href="/artists/b">b</a>
                                <a data-letter="c" href="/artists/c">c</a>
                                <a data-letter="d" href="/artists/d">d</a>
                                <a data-letter="e" href="/artists/e">e</a>
                                <a data-letter="f" href="/artists/f">f</a>
                                <a data-letter="g" href="/artists/g">g</a>
                                <a data-letter="h" href="/artists/h">h</a>
                                <a data-letter="i" href="/artists/i">i</a>
                                <a data-letter="j" href="/artists/j">j</a>
                                <a data-letter="k" href="/artists/k">k</a>
                                <a data-letter="l" href="/artists/l">l</a>
                                <a data-letter="m" href="/artists/m">m</a>
                                <a data-letter="n" href="/artists/n">n</a>
                                <a data-letter="o" href="/artists/o">o</a>
                                <a data-letter="p" href="/artists/p">p</a>
                                <a data-letter="q" href="/artists/q">q</a>
                                <a data-letter="r" href="/artists/r">r</a>
                                <a data-letter="s" href="/artists/s">s</a>
                                <a data-letter="t" href="/artists/t">t</a>
                                <a data-letter="u" href="/artists/u">u</a>
                                <a data-letter="v" href="/artists/v">v</a>
                                <a data-letter="w" href="/artists/w">w</a>
                                <a data-letter="x" href="/artists/x">x</a>
                                <a data-letter="y" href="/artists/y">y</a>
                                <a data-letter="z" href="/artists/z">z</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="featured__container">
                    {data.map((d) => <ArtistCellFeatured key={d.ArtistId} data={d} onFollowChange={this.handleFollowChange} />)}
                </div>
            </React.Fragment>
        );
    }
}

function ArtistCellFeatured(props) {
    const data = props.data || {};
    let imageStyle;
    if (data.Image) {
        imageStyle = { backgroundImage: `url('${data.Image.MediumUrl}')` };
    }
    return (
        <div className="featured__box featured--default">
            <div className="featured__inner">
                <div className="featured__inner__img" style={imageStyle} />
                <div className="featured__spacer">
                    <a href={`/artist/${data.Slug}`}>
                        <h4>{data.Name}</h4>
                    </a>
                    <FollowButton data={data} onChange={props.onFollowChange} />
                </div>
            </div>
        </div>
    );
}

function ArtistsForGenre(props) {
    const data = Genre.values[props.genre] || {};
    const q = { genre: data.value, limit: 20, offset: 0, type: 1 };
    const titleContent = (
        <Title small={true}>
            <h2>{data.display}</h2>
            <Arrows config={{ size: 'small' }} display="See All" link={`/artists/categories/${props.genre}`} />
        </Title>
    )
    return (
        <ArtistsSlider
            className="spacer--bottom"
            id={data.value}
            q={q}
            titleContent={titleContent}
            url={Artcloud.url.vendor.marketplace.artists.get()} />
    )
}

export default Artists;